import { createContext, useContext } from "react";

export const RegionContext = createContext<string | null>(null);

export const RegionProvider = RegionContext.Provider;

export function useRegion() {
  const region = useContext(RegionContext);
  if (region === null) {
    throw new Error("useRegion is read before being set");
  }
  return region;
}
